import React, { useContext } from 'react';
import { WidgetType } from 'widgets/WidgetType';
import { Button } from '@instinet-analytics/semantic-ui-components';
import './MultipleInput.scss';
import AppContext from 'app/AppContext';
import { WidgetId } from 'widgets/WidgetId';

interface MultipleInputProps extends WidgetId {
    componentType: WidgetType;
    placeInTab: () => void;
    remove: () => void;
}

export default function MultipleInput(props: MultipleInputProps) {
    const { componentType, placeInTab, remove, widgetKey, widgetType } = props;
    const {
        services: { widgetsService },
    } = useContext(AppContext);

    const componentTitle = widgetsService.getWidgetTitle(componentType);
    const title = `Multiple ${componentTitle}s Active`;
    const message =
        `Only one ${componentTitle} may be active at a time. ` +
        `You may either remove this one, or place it in a tab and look at one at a time.`;

    return (
        <div
            className="Widget MultipleInput"
            data-widget-key={widgetKey}
            data-widget-type={widgetType}
        >
            <div className="MultipleInput-title">{title}</div>
            <div className="MultipleInput-message">{message}</div>
            <Button onClick={remove} className="primary">
                {`Remove ${componentTitle}`}
            </Button>
            <Button onClick={placeInTab} className="inverted place-in-tab-btn">
                Place In Tab
            </Button>
        </div>
    );
}
